import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/master/sponsor', {params});
  },
  detail(id: string | number, params = {}) {
    return axios.get(`/master/sponsor/${id}`, {params});
  },
  create(payload = {}) {
    return axios.post('/master/sponsor', payload);
  },
  update(id: string | number, payload = {}) {
    return axios.put(`/master/sponsor/${id}`, payload);
  },
  delete(id: string | number) {
    return axios.delete(`/master/sponsor/${id}`);
  },
  attachProduct(id: string | number, payload = {}) {
    return axios.post(`/master/sponsor/${id}/products`, payload);
  },
  productSponsor(id: string | number, params = {}) {
    return axios.get(`/master/sponsor/${id}/products`, {params});
  },
  attactDelete(id: string | number, params = {}) {
    return axios.delete(`/master/sponsor/${id}/products`, {params});
  },
};
